module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-2.43148828.png";